/**
 * Vid2Frames - Main Entry Point (TypeScript + Vite)
 */

import '../css/styles.css';
import '../css/views/home.css';
import { HomeView } from './ts/views/home-view';
import { ApiKeyManager } from './ts/api-keys';

function initApiModal() {
  const openBtn = document.getElementById('open-api-modal-btn');
  const closeBtn = document.getElementById('close-api-modal-btn');
  const modal = document.getElementById('api-access-modal');
  const container = document.getElementById('api-keys-list-container');

  if (!openBtn || !modal || !container) return;

  function renderKeys() {
    const keys = ApiKeyManager.getKeys();

    container!.innerHTML = keys.map(k => `
      <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; background: rgba(255,255,255,0.03); border-radius: 8px; font-family: monospace;">
        <div>
          <div style="font-weight: 700; color: #a7f3d0; font-size: 13px;">${k.key}</div>
          <div style="font-size: 11px; color: #71717a; margin-top: 3px;">Name: ${k.name} | Status: Public Access</div>
        </div>
        <div>
          <span style="background: rgba(14, 165, 233, 0.15); border: 1px solid rgba(14, 165, 233, 0.3); color: #38bdf8; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 4px; letter-spacing: 0.5px;">PUBLIC KEY</span>
        </div>
      </div>
    `).join('');
  }

  openBtn.addEventListener('click', () => {
    modal.style.display = 'flex';
    renderKeys();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }
}

function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then((reg) => {
        console.log('Vid2Frames PWA ServiceWorker registered:', reg.scope);
      }).catch((err) => {
        console.warn('Vid2Frames PWA ServiceWorker registration failed:', err);
      });
    });
  }
}

(window as any).HomeView = HomeView;
(window as any).ApiKeyManager = ApiKeyManager;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    HomeView.init();
    initApiModal();
    registerServiceWorker();
  });
} else {
  HomeView.init();
  initApiModal();
  registerServiceWorker();
}
